import { render, staticRenderFns } from "./BoxDetailStockPei.vue?vue&type=template&id=7cac758f&scoped=true&"
import script from "./BoxDetailStockPei.vue?vue&type=script&lang=js&"
export * from "./BoxDetailStockPei.vue?vue&type=script&lang=js&"
import style0 from "./BoxDetailStockPei.vue?vue&type=style&index=0&id=7cac758f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cac758f",
  null
  
)

export default component.exports